import React, { useEffect, useState } from "react";
import {
  Paper,
  Typography,
  Switch,
  FormControlLabel,
  Divider,
} from "@mui/material";
import "./DisplayAIFlags.css";

const DisplayAIFlags = () => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [flags, setFlags] = useState({});

  // ================= FETCH FLAGS =================

  useEffect(() => {
    fetchFlags();
  }, []);

  const fetchFlags = async () => {
    try {
      const response = await fetch(
        `${API_URL}/v1/ai-flags-admin`
      );

      const result = await response.json();

      setFlags(result.flags || {});
    } catch (error) {
      console.error("Error fetching flags:", error);
    }
  };

  // ================= TOGGLE FLAG =================

  const handleToggle = async (
    featureKey,
    isEnabled
  ) => {
    try {
      const response = await fetch(
        `${API_URL}/v1/ai-flags-admin/${featureKey}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            isEnabled,
          }),
        }
      );

      if (response.ok) {
        setFlags((prev) => ({
          ...prev,
          [featureKey]: isEnabled,
        }));
      }
    } catch (error) {
      console.error(
        "Toggle error:",
        error
      );
    }
  };

  return (
    <Paper
      sx={{
        p: 3,
        maxWidth: 700,
        margin: "30px auto",
      }}
    >
      <Typography
        variant="h5"
        gutterBottom
      >
        AI Feature Flags
      </Typography>

      <Divider sx={{ mb: 2 }} />

      {Object.entries(flags).map(
        ([featureKey, enabled]) => (
          <FormControlLabel
            key={featureKey}
            sx={{
              display: "flex",
              justifyContent:
                "space-between",
              ml: 0,
              mb: 1,
            }}
            control={
              <Switch
                checked={enabled}
                onChange={(e) =>
                  handleToggle(
                    featureKey,
                    e.target.checked
                  )
                }
                color="primary"
              />
            }
            label={
              <Typography>
                {featureKey}
              </Typography>
            }
            labelPlacement="start"
          />
        )
      )}
    </Paper>
  );
};

export default DisplayAIFlags;